import { render, staticRenderFns } from "./ContactHoverView.vue?vue&type=template&id=0ff017c3&scoped=true&"
import script from "./ContactHoverView.vue?vue&type=script&lang=js&"
export * from "./ContactHoverView.vue?vue&type=script&lang=js&"
import style0 from "./ContactHoverView.vue?vue&type=style&index=0&id=0ff017c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff017c3",
  null
  
)

export default component.exports